// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import CreditMemo, {getDefaultState as getCreditMemoDefaultState} from './report';
import Criteria, {getDefaultState as getCriteriaDefaultState} from './criteria';
import GridApi, {getDefaultState as getGridApiDefaultState} from './grid-api';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollectionState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import ReportIsScrollable, {getDefaultState as getReportIsScrollableDefaultState} from '../../shared/state/report-is-scrollable';
import SelectedDealers, {getDefaultState as getSelectedDealersDefaultState} from './selected-dealers';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    claimTypes: KeyValuePairCollection,
    criteria: Criteria,
    gridApi: GridApi,
    isDisplayCreditMemoDisabled: t.Boolean,
    report: CreditMemo,
    reportIsScrollable: ReportIsScrollable,
    selectedDealers: SelectedDealers,
    showNoResultsFound: t.Boolean,
    showSelectAll: t.Boolean
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        claimTypes: getDefaultKeyValueCollectionState(),
        criteria: getCriteriaDefaultState(),
        gridApi: getGridApiDefaultState(),
        isDisplayCreditMemoDisabled: true,
        report: getCreditMemoDefaultState(),
        reportIsScrollable: getReportIsScrollableDefaultState(),
        selectedDealers: getSelectedDealersDefaultState(),
        showNoResultsFound: false,
        showSelectAll: true
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state/index.js